/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Factor } from './Factor';
import {
    FactorFromJSON,
    FactorFromJSONTyped,
    FactorToJSON,
} from './Factor';
import type { IDRequestMetadata } from './IDRequestMetadata';
import {
    IDRequestMetadataFromJSON,
    IDRequestMetadataFromJSONTyped,
    IDRequestMetadataToJSON,
} from './IDRequestMetadata';
import type { PersonHandle } from './PersonHandle';
import {
    PersonHandleFromJSON,
    PersonHandleFromJSONTyped,
    PersonHandleToJSON,
} from './PersonHandle';

/**
 * 
 * @export
 * @interface IDRequestV2
 */
export interface IDRequestV2 {
    /**
     * 
     * @type {PersonHandle}
     * @memberof IDRequestV2
     */
    handle?: PersonHandle;
    /**
     * 
     * @type {Factor}
     * @memberof IDRequestV2
     */
    factor?: Factor;
    /**
     * 
     * @type {IDRequestMetadata}
     * @memberof IDRequestV2
     */
    metadata?: IDRequestMetadata;
}

/**
 * Check if a given object implements the IDRequestV2 interface.
 */
export function instanceOfIDRequestV2(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IDRequestV2FromJSON(json: any): IDRequestV2 {
    return IDRequestV2FromJSONTyped(json, false);
}

export function IDRequestV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): IDRequestV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'handle': !exists(json, 'handle') ? undefined : PersonHandleFromJSON(json['handle']),
        'factor': !exists(json, 'factor') ? undefined : FactorFromJSON(json['factor']),
        'metadata': !exists(json, 'metadata') ? undefined : IDRequestMetadataFromJSON(json['metadata']),
    };
}

export function IDRequestV2ToJSON(value?: IDRequestV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'handle': PersonHandleToJSON(value.handle),
        'factor': FactorToJSON(value.factor),
        'metadata': IDRequestMetadataToJSON(value.metadata),
    };
}

